import React from 'react';
import PropTypes from 'prop-types';

import TextField from './text_field';

const ZipFormat = /^\d{5}(?:[-\s]\d{4})?$/;

class PostalCodeField extends TextField {
  constructor(props) {
    super(props);

    this.fieldType = 'tel';
    this.validations.push(this.validatePostalCodeFormat);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.validate !== this.props.validate) {
      this.validate(this.displayErrors);
    }
  }

  validatePostalCodeFormat(value) {
    if (this.props.validate && !ZipFormat.test(value)) {
      return 'Postal Code is formatted incorrectly';
    }
  }
}

PostalCodeField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validate: PropTypes.bool.isRequired
};

export default PostalCodeField;
